import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import { Router, ActivatedRoute } from "@angular/router";
import { Injectable, Inject } from '@angular/core';
import { ApiUrls } from '../_enums/apiUrls';
import { Deferred } from "ts-deferred";
import { StatusCode } from '../_enums/Common';
import { RouteUrls } from '../_enums/routeUrls';
import { TranslateService } from '@ngx-translate/core';
import { EmailData, ListingParams } from '../_models/common/listingParams';
import { SystemPages } from '../_enums/systemPages';
import { FileInfo } from '../_component/assessmentFormTest/interface/assessment-form-test.interface';


@Injectable()
export class CommonService {
  gatewayUrl: any;
  public ApiUrls = ApiUrls;
  public RouteUrls = RouteUrls;
  public SystemPages = SystemPages;
  public storageKey;
  public serviceUrl;
  public selectedRecord = [];
  public emailData = {} as EmailData;
  public _baseUrl;
  public desktopUrl;
  public ssoConfig;
  public loginButtonText = 'Log in'
  constructor(
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private http: HttpClient,
     @Inject('BASE_URL') baseUrl: string,
  )
  {
    this._baseUrl = baseUrl;
    this.serviceUrl = this.GetFromLocalStorage('gatewayUrl');
    try {
      var setting = this.getSettings();
      this.serviceUrl = setting.GatewayUrl;
      this.storageKey = setting.StorageKey;
      this.ssoConfig = setting.SSOConfig;
      this.desktopUrl = setting.ClientSetting.DesktopUrl;
      if (!this.translate.currentLang) {
        translate.setDefaultLang(this.GetFromLocalStorage('lang'));
        translate.use(this.GetFromLocalStorage('lang'));
      }
      //localStorage.setItem('gatewayUrl');
    } catch (e) {

    }
  }

  public getSettings(): any {
    return this.JsonParseData(document.getElementById('setting-container')?.getAttribute("data-settings"));
  }
  public NavigateToRouteWithQueryString(routeName: string, queryParams?:any) {
    if (queryParams == undefined || queryParams == null)
      this.router.navigate([routeName]);
    else
      this.router.navigate([routeName], queryParams);
  }

  public SetAccessToken(data:any) {
    return this.SetLocalStorage("auth_token", "Bearer " + data);
  }
  public SetLocalStorage(key: string, data: any) {
    key = this.storageKey + key;
    localStorage.setItem(key, data);
  }
  public GetFromLocalStorage(key: string): string {
    key = this.storageKey + key;
    try {
      return  localStorage.getItem(key) ?? "";

    } catch (e) {
      return localStorage.getItem(key) ?? "";
    }
  }
  public GetLoggedinUserInfo() {
    return this.JsonParseData(this.GetFromLocalStorage("jt_user_info"));
  }
  public RemoveLocalStorage(key:string) {
    key = this.storageKey + key;
    localStorage.removeItem(key);
  }
  public GetWhiteLabelPermissions() {
    return this.JsonParseData(this.GetFromLocalStorage("whiteLabel_permissions"));
  }
  public GetAccessToken() {
    return this.GetFromLocalStorage("auth_token");
  }
  public GetPermissions() {
    return  this.JsonParseData(this.GetFromLocalStorage("jt_permissions"));
  }
  get(api: string) {
    var token = this.GetFromLocalStorage('auth_token');
    let headers = new
      HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Expose-Headers': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });

    //console.log(token);
    //headers.append('Authorization', token);
    let options = { headers: headers };
    return this.http
      .get(this.serviceUrl + api, options);
    // .map(response => response.json());
  }


  public SaveAndNotify(apiUrl: string, data: any, navigateUrl?: string | null, navigateParams?: any, messageKey?: string | null, saveMsg = false) {
    let d = new Deferred<any>();
    let p = d.promise;
    //this.Loader.show();
    this.post(apiUrl, data)
      .subscribe((data: any) => {

        let result: any;
        try {

          if (typeof data == "string") {
            result = this.JsonParseData(data);
          }
          else {
            result = data;
          }
          // result =  this.JsonParseData( data.json());
        }
        catch (e) {

        }

        if (result.status == StatusCode.OK) {
          messageKey = (messageKey != null && messageKey != undefined) ? messageKey : "Messages.Save";
         // this.Notification.success(this.GetTranslation(messageKey), false, saveMsg);
          if (navigateUrl != null && navigateUrl != undefined) { }
           // this.NavigateToRoute(navigateUrl, navigateParams);
        }
        else {
         // (messageKey != null && messageKey != undefined) ? this.Notification.error(this.GetTranslation(messageKey)) : this.Notification.error(this.GetTranslation("Messages.Error"));
        }
        //this.Loader.hide();
        d.resolve(result);
      }, error => {
       // this.Loader.hide();
       // this.Notification.error(this.GetTranslation("Messages.Error")); console.log("erre", error);
      });
    return p;
  }


  public GetData(apiUrl: string, showLoader?: boolean | undefined, token?: string | undefined): Promise<any> {


    let d = new Deferred<any>();
    let p = d.promise;

    try {
      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }
      this.get(apiUrl).subscribe(data => {
        let result: any;
        if (typeof data == 'string') {
          result = this.JsonParseData(data);
        } else {
          result = data;
        }

        d.resolve(result);
      }, error => {
        console.log('erre', error);
      });
      return p;
    }
    catch (e) {
      d.reject(e);
      return p;
    }
  }


  
  public JsonParseData(data: any) {
    let result = data;
    try {
      result = JSON.parse(data);
    } catch (e) {
      console.log(e)
    }
    return result;
  }

  post(api: string, data: any) {
    var token = this.GetFromLocalStorage('auth_token');
    let headers = new HttpHeaders();
    if (token != null && token != "") {
      headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });
    }
    else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token
      });
    }
    // headers.append('Authorization', localStorage.getItem('auth_token'));
    let options = { headers: headers };
    return this.http
      .post(this.serviceUrl + api, JSON.stringify(data), options);
    //.map(response => response.json());

  }
 
  public PostData(apiUrl: string, data: any, showLoader?: boolean, token?: string | null): Promise<any> {
    let d = new Deferred<any>();
    let p = d.promise;
    try {
      if (apiUrl == 'undefined' || apiUrl == null || apiUrl == "") {
        d.reject("e");
        return p;
      }
      this.post(apiUrl, data).subscribe(data => {

        let result: any;
        if (typeof data == 'string') {
          result = this.JsonParseData(data);
        } else {
          result = data;
        }
        d.resolve(result);
      },
        error => {
          console.log('error', error);
          d.reject(error);
        }
      );
      return p;
    }
    catch (e) {
      d.reject(e);
      return p
    }


  }





  public RemoveAccessToken() {
    return this.RemoveLocalStorage("auth_token");
  }
  public logOut(relaod = true, clearToken = true) {
    let $that = this;
    let loginUrl = 'Login';
    //if (this.ssoConfig != undefined) {
    //  if (this.ssoConfig.SingleSignOn == "Yes" && this.ssoConfig.SingleSignOn_Type == "Microsoft" && this.ssoConfig.ForceSingleSignIn_Microsoft == "Y") {
    //    loginUrl = 'Login1';
    //  }
    //}

    try {
      this.PostData(this.ApiUrls.SystemUser.RevokeToken, null, true).then(function (data) {

        if (data.status == StatusCode.OK) {

          $that.ClearLocalStorageOnlogOut(clearToken);
          if (relaod)
            window.location.href = loginUrl;
          //this.router.navigate(["Login"]);
        }
        else {
          if (relaod)
            window.location.href = loginUrl;
          //$that.Notification.error($that.GetTranslation("Messages.Error"));
        }
      }).catch(function (data) {
        $that.ClearLocalStorageOnlogOut(clearToken);
        if (relaod)
          window.location.href = loginUrl;
      });

    } catch (e) {
      $that.ClearLocalStorageOnlogOut(clearToken);
      if (relaod)
        window.location.href = loginUrl;
    }
  }

  public ClearLocalStorageOnlogOut(clearToken = true) {
    let $that = this;
    $that.RemoveLocalStorage("en");
    if (clearToken)
      $that.RemoveAccessToken();
    $that.RemoveLocalStorage('jt_permissions');
    $that.RemoveLocalStorage('jt_user_info');
    $that.RemoveLocalStorage('QuickLinks');
    $that.RemoveLocalStorage('QuickLinksLogoAndNotifications');
    $that.RemoveLocalStorage('TotalNotifications');
    $that.RemoveLocalStorage('whiteLabel_permissions');
  }

  public getBrowserInfo(): string {

    return "Google Chrome";
    // return this.deviceService.userAgent;
  }


  public SaveData(apiUrl: string, data: any, navigateUrl?: string | null, queryParams?: any, messageKey?: string | null, saveMsg = false): Promise<any> {
    let d = new Deferred<any>();
    let p = d.promise;
    try {
      this.PostData(apiUrl, data, true).then(data => {
        var result = data;
        if (result.status == StatusCode.OK) {
          if (navigateUrl != null && navigateUrl != undefined)
            this.NavigateToRouteWithQueryString(navigateUrl, queryParams);
        }
        else {
        //  this.Notification.error(this.GetTranslation("Messages.Error"));
        }
      //  this.Loader.hide();
        d.resolve(result);
      });
      return p;
    } catch (e) {
      console.log(e);
      return p
    }

  }

  public docType = '';

  GetDocType(type: string) {
    if (type) {
      switch (type.toUpperCase()) {
        case ".DOC":
          this.docType = 'Application/msword';
          break;
        case ".DOCX":
          this.docType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case ".TXT":
          this.docType = 'text/plain';
          break;
        case ".GIF":
          this.docType = 'Image/GIF';
          break;
        case ".JPG":
          this.docType = 'Image/JPEG';
          break;
        case ".JPEG":
          this.docType = 'Image/JPEG';
          break;
        case ".XLS":
          this.docType = 'Application/vnd.ms-excel';
          break;
        case ".XLSX":
          this.docType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case ".PPTX":
          this.docType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        case ".PPT":
          this.docType = 'application/vnd.ms-powerpoint';
          break;
        case ".PDF":
          this.docType = 'application/PDF';
          break;
        case ".PNG":
          this.docType = 'image/png';
          break;
      }
    }

    return this.docType;
  }


  DownLoadFile(fileInfo: FileInfo) {

    let url = this.GetObjectURL(fileInfo.content, fileInfo.extention);
    if (window.navigator.userAgent.toLowerCase().indexOf('trident') > -1) {

      //window.navigator.msSaveBlob(url, fileInfo.extention);
    }

    else if (navigator.userAgent.match('CriOS')) {
      var reader = new FileReader();
      var out = this.Base64toBlob(fileInfo.content, this.GetDocType(fileInfo.extention));
      reader.onload = function (e) {
        window.location.href = reader.result as string;
      }
      reader.readAsDataURL(out);
    }


    else {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = url;
      link.download = fileInfo.name;

      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }


  FileURL(fileInfo: FileInfo) {
    return this.GetObjectURL(fileInfo.content, fileInfo.extention);
  }

  GetObjectURL(base64String: string, fileExtention: string) {
    var binaryString = window.atob(base64String);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return URL.createObjectURL(new Blob([bytes.buffer], { type: this.GetDocType(fileExtention) }));

  }
  public cleanExtraCharactors(content: string) {
    content = content.replace(new RegExp('&lt;&lt;', 'g'), '{');
    content = content.replace(new RegExp('&gt;&gt;', 'g'), '}');
    content = content.replace(new RegExp('&nbsp;', 'g'), ' ');
    content = content.replace(new RegExp('&lt;', 'g'), '<');
    content = content.replace(new RegExp('&gt;', 'g'), '>');
    // content = content.replace(new RegExp('&lt;', 'g'), '"');
    return content;
  }

  getTranslateFile() {
    return JSON.parse(this.GetFromLocalStorage(this.translate.currentLang));
  }
  public GetTranslation(key: string) {
    
    var translation = this.getTranslateFile();
    if (key.length > 0) {
      var sections = key.split('.');
      for (var i = 0; i < sections.length; i++) {
        translation = translation[sections[i]];
      }
    }
    return translation;
  }

  public Base64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public RedirectToLogin() {
    let loginUrl = 'Login';
    this.ClearLocalStorageOnlogOut();
    window.location.assign(loginUrl);
    // window.location.href = loginUrl;
  }
  public isNullOrWhiteSpace(str: string): boolean {
    if (str == "" || str == null || str == undefined) {
      return true;
    }
    return false;
  }

  public initListingParams(): ListingParams {
    let listingParams = {} as ListingParams;
    listingParams.pageSize = 20;
    listingParams.systemPageId = -1;
    listingParams.isAscendingSort = true;
    listingParams.printSelectedRecords = true;
    listingParams.customfieldValues = [];
    listingParams.gridTableClass = "";
    return listingParams;
  }
}
